import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BaseUiModule } from '@mitsubishi/shared/ui';

import { ClassSelectionComponent } from './class-selection.component';

@NgModule({
  declarations: [ClassSelectionComponent],
  imports: [CommonModule, BaseUiModule],
  exports: [ClassSelectionComponent],
})
export class ClassSelectionModule {}
